(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("rockplate"));
	else if(typeof define === 'function' && define.amd)
		define(["rockplate"], factory);
	else if(typeof exports === 'object')
		exports["rockplate-codemirror"] = factory(require("rockplate"));
	else
		root["rockplate-codemirror"] = factory(root["rockplate"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_rockplate__) {
return 